<template lang="pug">
  extends TableRowBase.pug
</template>

<script>
  import TableRowBase from './TableRowBase.vue';

  export default {
    name: 'TableRowAvgPatientNetRev',
    extends: TableRowBase,
    methods: {
      getCalculatedYtd(yearObj, throughMonth) {
        return this.getRatio(
          this.getYtdByField(yearObj, 'net_ha_revenue', throughMonth),
          this.getYtdByField(yearObj, 'number_patients_purchased', throughMonth),
          0);
      },
    },
  };
</script>
